module.exports = __webpack_public_path__ + "img/33_12.3f27d229.png";